export default [
  {
    path: "/marketing/homeConfig",
    component: () => import("../../pages/marketing/homeManage.vue"),
    name: "homeConfig",
    title: "首页配置",
    meta: {
      title: "首页配置"
    }
  },
  {
    path: "/marketing/productManage",
    component: () => import("../../pages/marketing/productManage.vue"),
    name: "homeProductConfig",
    title: "住宅产品配置",
    meta: {
      title: "住宅产品配置"
    }
  },
  {
    path: "/marketing/brandCategoryManage",
    component: () => import("../../pages/marketing/brands/brandCategoryManage.vue"),
    name: "homeBrandsManage",
    title: "麓系品牌配置",
    meta: {
      title: "麓系品牌配置"
    }
  },
  {
    path: "/marketing/setBrands",
    component: () => import("@/pages/marketing/brands/setBrands.vue"),
    name: "marketingSetBrands",
    title: "麓系品牌配置",
    meta: {
      title: "麓系品牌配置"
    }
  },
  {
    path: "/marketing/evaluation",
    component: () => import("@/pages/marketing/product/evaluation.vue"),
    name: "evaluation",
    title: "媒体评价",
    meta: {
      title: "媒体评价"
    }
  },
  {
    path: "/marketing/rights/manage",
    component: () => import("@/pages/marketing/lukeCenter/rights/rightsManage.vue"),
    name: "rightsManage",
    title: "权益管理",
    meta: {
      title: "权益管理"
    }
  },
  {
    path: "/marketing/rights/order",
    component: () => import("@/pages/marketing/lukeCenter/rights/rightsOrder.vue"),
    name: "rightsOrder",
    title: "权益订单",
    meta: {
      title: "权益订单"
    }
  },
  {
    path: "/marketing/lostFound/manage",
    component: () => import("@/pages/marketing/platform/lostFoundList.vue"),
    name: "lostFoundManage",
    title: "失物招领管理",
    meta: {
      title: "失物招领管理"
    }
  },
  {
    path: "/marketing/book/activity",
    component: () => import("@/pages/marketing/bookActivity/bookActivityManage.vue"),
    name: "bookActivity",
    title: "预约活动管理",
    meta: {
      title: "预约活动管理"
    }
  },
  {
    path: "/marketing/book/activity/order",
    component: () => import("@/pages/marketing/bookActivity/bookActivityOrder.vue"),
    name: "bookActivityOrder",
    title: "预约活动订单管理",
    meta: {
      title: "预约活动订单管理"
    }
  }
];
